<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" :mini-variant="miniVariant" :clipped="clipped" class="navigation" app :temporary="$vuetify.breakpoint.xsAndDown" :style="{ 'z-index': 100 }">
      <v-list dense class="menuheader">
        <v-list-item class="px-2">
          <v-list-item class="px-0" :to="{ name: 'PerfilUsuario' }" :title="miniVariant ? $store.getters.getUserData.nombre : ''">
            <v-list-item-avatar style="margin: 0 16px 0 0">
              <v-img :src="fotoPerfil" />
            </v-list-item-avatar>
            <v-list-item-content class="pa-0">
              <v-list-item-title class="text-h7" v-text="$store.getters.getUserData.nombre" />
              <v-list-item-subtitle v-text="$store.getters.getUserData.username" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item-icon style="margin: 0 5px 0 5px">
            <v-menu offset-y offset-x transition="scale-transition">
              <template #activator="{ on: menu, attrs }">
                <v-btn icon v-bind="attrs" v-on="menu">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list class="menuheader" dense>
                <v-list-item @click="askForLogOut()">
                  <v-list-item-icon>
                    <v-icon>no_encryption</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("view.home.cerrarSesion.text") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'PerfilUsuario' }">
                  <v-list-item-icon>
                    <v-icon>person_pin</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("view.home.perfilUsuario.text") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <div v-bar="{ preventParentScroll: true }" class="menu_scroll">
        <v-list dense nav>
          <v-list-item-group v-model="selectedItem" color="primary">
            <template v-for="(item, i) in items">
              <v-list-item
                v-if="!item.children && (item.permission === undefined || $userPermission.hasPermission(item.permission))"
                :id="i"
                :key="i"
                :to="item.action"
                :class="i == 0 ? fixClass : ''"
                :title="miniVariant ? item.text : ''">
                <v-list-item-icon>
                  <v-icon v-text="item.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text" />
                </v-list-item-content>
              </v-list-item>

              <v-list-group
                v-else-if="item.children && (item.permission === undefined || $userPermission.hasPermission(item.permission))"
                :key="i + '_2'"
                :value="false"
                :prepend-icon="item.model ? item.icon : item['icon-alt']"
                append-icon=""
                :title="miniVariant ? item.text : ''">
                <v-list-item-title slot="activator" v-text="item.text" />

                <template v-for="(child, j) in item.children">
                  <v-list-item v-if="child.permission === undefined || $userPermission.hasPermission(child.permission)" :key="j" :to="child.action" :title="miniVariant ? child.text : ''">
                    <v-list-item-title v-if="!miniVariant" v-text="child.text" />
                    <v-list-item-icon>
                      <v-icon v-text="child.icon" />
                    </v-list-item-icon>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-app-bar color="primary" dense app dark :fixed="fixed" :clipped-left="clipped">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-btn class="hidden-sm-and-down" icon @click.stop="miniVariant = !miniVariant">
        <v-icon>{{ miniVariant ? "apps" : "apps" }}</v-icon>
      </v-btn>
      <v-btn class="hidden-sm-and-down" icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>

      <v-spacer />
      <v-flex text-center>
        <v-toolbar-title dense class="hidden-sm-and-down">{{ system }}</v-toolbar-title>
        <v-toolbar-title dense class="hidden-md-and-up">{{ view.titleHeading }}</v-toolbar-title>
      </v-flex>
      <v-spacer />

      <v-btn icon @click="askForLogOut()">
        <v-icon>no_encryption</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content id="container">
      <breadcrumbs />
      <v-fab-transition>
        <v-btn v-show="showButonTop" key="keyboard_arrow_up" color="primary" small fab fixed bottom right class="keyboard_arrow_up mb-6" @click="goToTop()">
          <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
      </v-fab-transition>
      <router-view ref="childView" v-scroll="onScroll" />
    </v-content>

    <v-footer app :fixed="fixed" :inset="clipped">
      <span class="pl-3">{{ $t("view.home.footer.sistema") }}</span>
      <v-spacer />
      <span class="pr-3"><strong>&copy;</strong> {{ $t("view.home.footer.copyRight") }}</span>
    </v-footer>

    <v-snackbars :objects.sync="snackbar" :timeout="900000" app top right>
      <template #default="{ message }">
        <v-alert v-model="snackbar.show" :type="JSON.parse(message).color" class="my-0 py-0 px-0">
          <h3 class="text-h9 my-0">
            {{ JSON.parse(message).code }}
          </h3>
          <div>
            {{ JSON.parse(message).message }}
          </div>
        </v-alert>
      </template>
      <template #action="{ close }">
        <v-btn icon @click="close()">
          <v-icon>mdi mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbars>
  </v-app>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Auth from "@/services/auth";
import * as actions from "@/constants/mutation-names";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { logoutSwal } from "@/constants/sweet-alerts";
import VSnackbars from "v-snackbars";

export default {
  name: "HomePage"
  , components: { "v-snackbars": VSnackbars }
  , data() {
    return {
      view: { titleHeading: "Inicio" }
      , clipped: true
      , drawer: true
      , fixed: true
      , selectedItem: null
      , items: [
        { icon: "home", text: this.$t("view.menu.inicio.text"), action: { name: "Feeds" }, permission: "ROLE_ACCESO_ACH" }
        , {
          icon: "security"
          , "icon-alt": "security"
          , text: this.$t("view.menu.seguridad.text")
          , action: { name: "Usuario" }
          , permission: "ROLE_ACCESO_SEGURIDAD"
          , model: false
          , children: [
            { icon: "account_box", model: false, text: this.$t("view.menu.seguridad.sub.usuario.text"), action: { name: "Usuario" } }
            , { icon: "people_outline", model: false, text: this.$t("view.menu.seguridad.sub.perfiles.text"), action: { name: "Perfil" } }
          ]
        }
        , {
          icon: "fas fa-list"
          , "icon-alt": "fas fa-list"
          , text: this.$t("view.menu.catalogosOperativos.text")
          , permission: "ROLE_ACCESO_OP"
          , model: false
          , children: [
            { icon: "fas fa-check", text: this.$t("view.menu.catalogosOperativos.sub.status.text"), action: { name: "Status" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-check-double", text: this.$t("view.menu.catalogosOperativos.sub.substatus.text"), action: { name: "SubStatus" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-hand-pointer", text: this.$t("view.menu.catalogosOperativos.sub.accion.text"), action: { name: "Accion" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-hand-holding-usd", text: this.$t("view.menu.catalogosOperativos.sub.vendor.text"), action: { name: "Vendor" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-file-invoice-dollar", text: this.$t("view.menu.catalogosOperativos.sub.rep.text"), action: { name: "Rep" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-bullhorn", text: this.$t("view.menu.catalogosOperativos.sub.campana.text"), action: { name: "Campana" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-plus-square", text: this.$t("view.menu.catalogosOperativos.sub.agregador.text"), action: { name: "Agregador" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-handshake", text: this.$t("view.menu.catalogosOperativos.sub.benefpref.text"), action: { name: "BenefPref" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-clipboard-list", text: this.$t("view.menu.catalogosOperativos.sub.tipo.text"), action: { name: "Tipo" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-address-book", text: this.$t("view.menu.catalogosOperativos.sub.contact.text"), action: { name: "Contact" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-shopping-basket", text: this.$t("view.menu.catalogosOperativos.sub.shoppings.text"), action: { name: "Shoppings" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-question-circle", text: this.$t("view.menu.catalogosOperativos.sub.posTest.text"), action: { name: "PosTest" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-phone-volume", text: this.$t("view.menu.catalogosOperativos.sub.statusPreContacto.text"), action: { name: "StatusPreContacto" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-door-open", text: this.$t("view.menu.catalogosOperativos.sub.popEntryExit.text"), action: { name: "PopEntryExit" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "far fa-lightbulb", text: this.$t("view.menu.catalogosOperativos.sub.iniciativa.text"), action: { name: "Iniciativa" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-sign-out-alt", text: this.$t("view.menu.catalogosOperativos.sub.motivobaja.text"), action: { name: "MotivoBaja" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-sort-numeric-down", text: this.$t("view.menu.catalogosOperativos.sub.se.text"), action: { name: "Se" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-store", text: this.$t("view.menu.catalogosOperativos.sub.seOOB.text"), action: { name: "SeOOB" }, permission: "ROLE_ACCESO_OP" }
          ]
        }
        , {
          icon: "fas fa-book"
          , "icon-alt": "fas fa-book"
          , text: this.$t("view.menu.bases.text")
          , permission: "ROLE_ACCESO_OP"
          , model: false
          , children: [
            { icon: "fas fa-handshake", model: false, text: this.$t("view.menu.bases.sub.acuerdo.text"), action: { name: "Acuerdo" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-industry", model: false, text: this.$t("view.menu.bases.sub.subindustria.text"), action: { name: "SubIndustria" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-landmark", model: false, text: this.$t("view.menu.bases.sub.banco.text"), action: { name: "Banco" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-barcode", model: false, text: this.$t("view.menu.bases.sub.codigoindustrial.text"), action: { name: "CodigoIndustrial" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-user-tie", model: false, text: this.$t("view.menu.bases.sub.partner.text"), action: { name: "Partner" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-truck-loading", model: false, text: this.$t("view.menu.bases.sub.proveedorpos.text"), action: { name: "ProveedorPos" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-sticky-note", model: false, text: this.$t("view.menu.bases.sub.merchandising.text"), action: { name: "Merchandising" }, permission: "ROLE_ACCESO_OP" }
            , { icon: "fas fa-vote-yea", model: false, text: this.$t("view.menu.bases.sub.canalaceptacion.text"), action: { name: "CanalAceptacion" }, permission: "ROLE_ACCESO_OP" }
          ]
        }
        , {
          icon: "fas fa-globe-americas"
          , "icon-alt": "fas fa-globe-americas"
          , text: this.$t("view.menu.catalogosGeograficos.text")
          , permission: "ROLE_ACCESO_GR"
          , model: false
          , children: [
            { icon: "fas fa-globe", model: false, text: this.$t("view.menu.catalogosGeograficos.sub.pais.text"), action: { name: "Pais" }, permission: "ROLE_ACCESO_GR" }
            , { icon: "fas fa-map", text: this.$t("view.menu.catalogosGeograficos.sub.provincia.text"), action: { name: "Provincia" }, permission: "ROLE_ACCESO_GR" }
            , { icon: "fas fa-map-marker-alt", text: this.$t("view.menu.catalogosGeograficos.sub.localidad.text"), action: { name: "Localidad" }, permission: "ROLE_ACCESO_GR" }
            , { icon: "fas fa-phone", text: this.$t("view.menu.catalogosGeograficos.sub.lada.text"), action: { name: "Lada" }, permission: "ROLE_ACCESO_GR" }
          ]
        }
        , {
          icon: "fas fa-cogs"
          , "icon-alt": "fas fa-cogs"
          , text: this.$t("view.menu.catalogosGenerales.text")
          , permission: "ROLE_ACCESO_CATALOGOS"
          , model: false
          , children: [
            { icon: "content_copy", text: this.$t("view.menu.catalogosGenerales.sub.plantillasCorreo.text"), action: { name: "PlantillaCorreo" }, permission: "ROLE_ACCESO_CATALOGOS" }
            , { icon: "settings", text: this.$t("view.menu.catalogosGenerales.sub.parametros.text"), action: { name: "Parametros" }, permission: "ROLE_ACCESO_CATALOGOS" }
            , { icon: "fas fa-file", text: this.$t("view.menu.catalogosGenerales.sub.archivos.text"), action: { name: "Archivos" }, permission: "ROLE_ACCESO_CATALOGOS" }
          ]
        }
        , {
          icon: "history"
          , "icon-alt": "history"
          , text: this.$t("view.menu.consultaBitacoras.text")
          , permission: "ROLE_ACCESO_BITACORA"
          , model: false
          , children: [
            { icon: "mdi mdi-clock-fast", text: this.$t("view.menu.consultaBitacoras.sub.bitacora.text"), action: { name: "Bitacora" } }
            , {
              icon: "mdi mdi-database-search"
              , text: this.$t("view.menu.consultaBitacoras.sub.reportesAuditoria.text")
              , action: { name: "ReporteAuditoria" }
              , permission: "ROLE_ACCESO_REPORTES_AUDITORIA"
            }
            , { icon: "mdi mdi-email-search", text: this.$t("view.menu.consultaBitacoras.sub.monitorCorreos.text"), action: { name: "MonitorCorreos" }, permission: "ROLE_ACCESO_BITACORA" }
            , {
              icon: "fas fa-map-marked-alt"
              , text: this.$t("view.menu.consultaBitacoras.sub.geolocalizacion.text")
              , action: { name: "BitacoraGeolocalizacion" }
              , permission: "ROLE_ACCESO_TTS_BITACORA_GEOLOCALIZACION"
            }
          ]
        }
        , { icon: "fas fa-file-export", text: this.$t("view.menu.filetransaction.validator.text"), action: { name: "Validator" }, permission: "ROLE_ACCESO_VACH" }
        , { icon: "fas fa-file-import", text: this.$t("view.menu.filetransaction.importer.text"), action: { name: "Importer" }, permission: "ROLE_ACCESO_IACH" }
        , { icon: "mdi mdi-text-box-search", text: this.$t("view.menu.base.text"), action: { name: "Base" }, permission: "ROLE_ACCESO_BASE" }
        , {
          icon: "fas fa-chart-pie"
          , "icon-alt": "fas fa-chart-pie"
          , text: this.$t("view.menu.reportes.text")
          , permission: "ROLE_ACCESO_REPORTEEXCLUSIONES,ROLE_ACCESO_REPORTEUSUARIOS"
          , model: false
          , children: [
            {
              icon: "fas fa-store-slash"
              , model: false
              , text: this.$t("view.menu.reportes.sub.reporteexclusiones.text")
              , action: { name: "ReporteExclusiones" }
              , permission: "ROLE_ACCESO_REPORTEEXCLUSIONES"
            }
            , {
              icon: "fas fa-users"
              , model: false
              , text: this.$t("view.menu.reportes.sub.reporteusuarios.text")
              , action: { name: "ReporteUsuarios" }
              , permission: "ROLE_ACCESO_REPORTEUSUARIOS"
            }
            , {
              icon: "fas fa-map-marker-alt"
              , model: false
              , text: this.$t("view.menu.reportes.sub.reportevisitas.text")
              , action: { name: "ReporteVisitas" }
              , permission: "ROLE_ACCESO_REPORTEVISITAS"
            }
          ]
        }
      ]
      , showButonTop: false
      , miniVariant: false
      , right: true
      , rightDrawer: false
      , title: this.$t("view.home.welcome.text")
      , system: this.$t("view.home.footer.sistema")
      , snackbar: []
      , loading: false
    };
  }
  , computed: {
    fotoPerfil() {
      return this.$store.getters.getUserData.fotoPerfil ? this.$store.getters.getUserData.fotoPerfil : "/static/img/user_thumbnail.jpg";
    }
    , fixClass() {
      return this.$route.name.includes("Feeds") ? "" : "fix";
    }
  }
  , mounted() {
    this.setPageTitleHeading();
  }
  , updated() {
    this.setPageTitleHeading();
  }
  , created() {
    EventBus.$on(events.SESSION_TIME_FINISHED, (data) => {
      this.$router.push({ name: "SessionExpiredMessage", params: { username: data.username, nombre: data.nombre } });
    });

    EventBus.$on(events.SHOW_TOASTER_MESSAGE, (type, code, message, timeout = 6000) => {
      this.showToaster(type, code, message, timeout);
    });

    EventBus.$on(events.LOADING, (data) => {
      this.loading = data;
    });
  }
  , methods: {
    routeTo({ name }) {
      if (name == this.$route.name) {
        this.$router.go(this.$router.currentRoute);
      }
    }
    , async askForLogOut() {
      if ((await this.$swal(logoutSwal)).value) {
        await this.logOut();
      }
    }
    , async logOut() {
      try {
        this.$store.dispatch(actions.STOP_ID_SESSION_TIME_INTERVAL);
        await Auth.logOut();
        this.$store.dispatch(actions.AUTH_LOGOUT);
        this.$router.push("/auth");
      } catch (error) {
        console.err(error);
        throw error;
      }
    }
    , setPageTitleHeading() {
      if (this.$refs.childView === undefined) return "";
      this.view.titleHeading = this.$refs.childView.view.title || this.$t("view.home.footer.sistema");
    }
    , showToaster(type, code, message, timeout) {
      try {
        if (type.toLowerCase() === "success") {
          message = message || this.$t("errors.success");
        } else if (type.toLowerCase() === "error") {
          message = message || this.$t("errors.error");
        } else if (type.toLowerCase() == "warning") {
          message = message || this.$t("errors.warning");
        }
      } catch (error) {
        console.log(error);
        return false;
      }
      const obj = {
        message
        , code
        , color: type
        , timeout
      };
      obj.message = JSON.stringify(obj);
      this.snackbar.push(obj);
    }
    , onScroll() {
      this.showButonTop = document.documentElement.scrollTop > 0;
    }
    , goToTop() {
      this.$vuetify.goTo("#container", { duration: 300, offset: 0, easing: "easeInOutCubic" });
    }
  }
};
</script>

<style>
.v-list-item.fix {
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-list-item.fix .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}
.v-list-item.fix::before,
.v-list-item.fix:hover::before,
.v-list-item.fix:focus::before {
  opacity: 0 !important;
}

.menuheader .v-list-item--active::before,
.menuheader .v-list-item--active:hover::before,
.menuheader .v-list-item:focus::before {
  opacity: 0 !important;
}
.menuheader .v-list-item--active .v-icon,
.menuheader .v-list-item--active:hover .v-icon,
.menuheader .v-list-item:focus .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.menu_scroll {
  height: 93% !important;
}

@media (max-height: 850px) {
  .menu_scroll {
    height: 90% !important;
  }
}
@media (max-height: 600px) {
  .menu_scroll {
    height: 85% !important;
  }
}
.v-icon.notranslate.v-alert__icon {
  margin-top: auto;
  margin-bottom: auto;
}
.v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 16px;
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue